{"id":"Copyright","prefabs":{"default":{"children":[{"component":"Copyright","options":"options:*"}]}}}